<template>
  <vue-timepicker
    :value="_value"
    format="HH:mm"
    class="base-timepicker"
    :class="{ right }"
    hide-clear-button
    hide-disabled-hours
    hide-disabled-minutes
    auto-scroll
    :lazy="lazy"
    drop-direction="auto"
    :hour-range="hourRange"
    :minute-range="minuteRange"
    v-on="$listeners" />
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    VueTimepicker
  },
  props: {
    value: {
      type: String,
      required: true
    },
    // 'hh:mm'という形式で指定
    min: {
      type: String,
      default: '00:00'
    },
    // 'hh:mm'という形式で指定
    max: {
      type: String,
      default: null
    },
    right: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        // minより小さい値を入れようとした場合、minに上書き
        const [newValHH, newValMm] = v.split(':')
        const minHH = this.min ? this.min.split(':')[0] : '00'
        const minMm = this.min ? this.min.split(':')[1] : '00'
        if (+newValHH > +minHH || newValHH === minHH && +newValMm > +minMm) {
          this.$emit('input', v)
          return
        }
        this.$emit('input', this.min)
      }
    },
    hourRange() {
      const minHH = this.min ? this.min.split(':')[0] : '00'
      const maxHH = this.max ? this.max.split(':')[0] : '23'
      return [[minHH, maxHH]]
    },
    minuteRange() {
      const valueHH = this._value.split(':')[0]
      const minHH = this.min ? this.min.split(':')[0] : '00'
      if (valueHH === minHH) {
        const minMm = this.min ? this.min.split(':')[1] : '00'
        const maxMm = this.max ? this.max.split(':')[1] : '59'
        return [[minMm, maxMm]]
      }
      return [['00', '59']]
    },
  },
}
</script>

<style lang="scss">
.base-timepicker {
  width: 100%;
  min-width: 6em;

  input {
    width: 100% !important;
    border-radius: 0.25rem;
    text-align: center;
  }
  
  .dropdown {
    min-width: 13em;
    width: 100%;
    height: 14em;
    border-radius: 0.25rem;

    .select-list {
      width: 100%;
      height: 100%;
      border-radius: 0.25rem;

      ul {
        li:not([disabled]).active {
          background: #008EE3;
        }
      }
    }
  }

  &.right {
    .dropdown {
      left: auto;
      right: 0;
    }
  }
}
</style>